<template>
    <div>       
        <!-- Service Cards  - auskommentiert am 13.03.2023, da nicht benötigt.
        <v-container fluid style="background-color: #eeeeee">

            <div pb-3>
                <div class="headline">Services</div>

                <v-layout row wrap pt-0>

                    <v-flex xs12 sm6 md2 v-for="c in serviceCards" :key="c.cardId">

                        <Card v-bind:cardId="c.cardId"
                              v-bind:button1="c.button1"
                              v-bind:button2="c.button2"
                              v-bind:title="c.title"
                              v-bind:text="c.text"
                              v-bind:disabled_1="c.disabled_1"
                              v-on:event="processCardEvent">
                        </Card>
                    </v-flex>
                </v-layout>
            </div>

        </v-container>
		
		-->
		
        <!-- SAP Cards -->
        <v-container fluid style="background-color: #eeeeee" mt-1>

            <div pb-3>
                <div class="headline">SAP</div>

                <v-layout row wrap pt-0>

                    <v-flex xs12 sm6 md2 v-for="c in sapCards" :key="c.cardId">

                        <Card v-bind:cardId="c.cardId"
                              v-bind:button1="c.button1"
                              v-bind:button2="c.button2"
                              v-bind:title="c.title"
                              v-bind:text="c.text"
                              v-bind:disabled_1="c.disabled_1"
                              v-on:event="processCardEvent">
                        </Card>
                    </v-flex>
                </v-layout>
            </div>

        </v-container>

        <!-- DemoCards -->
        <v-container fluid style="background-color:#eeeeee" mt-1>
            <div>
                <div class="headline">Demos</div>
                <v-layout row wrap pt-0>

                    <v-flex xs12 sm3 md2 v-for="c in demoCards" :key="c.cardId">

                        <Card v-bind:cardId="c.cardId"
                              v-bind:button1="c.button1"
                              v-bind:button2="c.button2"
                              v-bind:title="c.title"
                              v-bind:text="c.text"
                              v-bind:disabled_1="c.disabled_1"
                              v-on:event="processCardEvent">
                        </Card>
                    </v-flex>
                </v-layout>
            </div>
        </v-container>

        <!-- Footer -->
        <v-footer height="auto"
                  color="lightgrey">
            <v-layout justify-center
                      row
                      wrap>
                <v-btn v-for="link in links"
                       :key="link"
                       flat
                       round
                       @click="uiEvent(link)">
                    {{ link }}
                </v-btn>
                <!-- Kontaktdialog -->
                <div class="text-xs-center">
                    <v-dialog v-model="dialog"
                              width="500">
                        <v-btn slot="activator"
                               flat
                               round>
                            Kontakt
                        </v-btn>

                        <v-card>
                            <v-card-title class="headline grey lighten-2"
                                          primary-title>
                                Kontakt
                            </v-card-title>

                            <v-card-text>
                                Bitte senden Sie eine E-mail an: dgreipl@haw-landshut.de
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary"
                                       flat
                                       @click="dialog = false">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>

                <v-flex color="lightgrey"
                        lighten-2
                        ma-0
                        text-xs-center
                        xs12>
                    &copy; &nbsp; Stand: &nbsp;{{version}} — Prof. Dr. Greipl
                </v-flex>
            </v-layout>
        </v-footer>


    </div>
</template>
<!-- style scoped src="@/assets/styles/mystyles.css" -->
<style scoped>
</style>

<script>
import Card from "./Card.vue";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
const config = require("./../../classes/myConfig").config;

// let imageUrl = require('./../../assets/img_landing/landing_codelab.jpg');

export default {
  name:"Landing",
  
  components: {
    Card
  },

  data: () => ({
    serviceCards: [ ],

    demoCards: [
      {
        cardId: "card_sprache",
        button1: "Demo",
        button2: "",
        title: "Voice Recognition",
        text: "Test voice recognition",
        disabled_1: false,
      },
      /* Auskommentiert am 10.8.2020, das das Dialogflow-API nicht mehr funktionier
                    {
                        cardId: "card_bot",
                        button1: "Demo",
                        button2: "",
                        title: "Chatbots",
                        text: "Test a Chatbot with Dialogflow"
                    },
                    */
    ],

    sapCards: [
      {
        cardId: "card_sap_account",
        button1: "Request access",
        button2: "",
        title: "S/4HANA-Access",
        text: " Beantragen das Learn-Users",
        disabled_1: false,
      },
/*
      {
        cardId: "card_sap_planning_strategies",
        button1: "Read",
        button2: "",
        title: "SAP Planning (Script)",
        text: "Deep Dive for Planning Strategies",
        disabled_1: true,
      },

      {
        cardId: "card_sap_youtube_planning_strategies",
        button1: "View on Youtube",
        button2: "",
        title: "SAP Planning (Youtube)",
        text: "Deep Dive for Planning Strategies on my Youtube channel",
        disabled_1: true,
      },

      {
        cardId: "card_sap_youtube_gbi",
        button1: "View on Youtube",
        button2: "",
        title: "SAP GBI (Youtube)",
        text: "SAP ECC GBI case study on my Youtube channel",
        disabled_1: true,
      },

            {
        cardId: "card_sap_odata",
        button1: "Demo",
        button2: "",
        title: "SAP S/4 Odata Demo",
        text: "How to integrate an Web App with SAP S/4 (be patient, work in progress)",
        disabled_1: true,
      },
      */
    ],

    version: process.env.VUE_APP_VERSION,
    dialog: false, // Für den Kontaktdialog
    baseUrl: process.env.BASE_URL,

    links: ["Impressum & Datenschutz"],
  }),

  methods: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    processCardEvent(card) {
      console.log("UPLAOD EVENT: --------------" + JSON.stringify(card));
      switch (card.cardId) {
        case "card_klausur":
          if (this.$store.getters.isAdmin) {
            this.$store.commit("setSnackbarText", "Admin-Zugang!");
            this.$router.push({ name: "einsicht" });
            break;
          }

          if (!this.$store.getters.isStudent) {
            this.drawer = false; // Close the menue
            this.$store.commit(
              "setSnackbarText",
              "Nur für angemeldete Studierende der HAW-Landshut"
            );
            break;
          } else {
            // this.$store.commit('setSnackbarText', 'Anmeldung für WS20/21 noch nicht möglich.');
            this.$router.push({ name: "einsicht" });
          }

          break;

        case "card_sprache":
          this.$router.push({ name: "speechtotext" });
          break;

        case "card_faq":
          window.open("https://the-technology-lab.gitbook.io/faq/", "_blank");
          break;

        case "card_bot":
          this.$router.push({ name: "chatbot" });
          break;

        case "card_test":
          if (this.$store.getters.isStudent | this.$store.getters.isAdmin) {
            this.$store.commit("setSnackbarText", "Beta Feature!");
            this.$router.push({
              name: "tests",
              params: { test_id: "demo" },
            });
          } else {
            this.$store.commit(
              "setSnackbarText",
              "Nur für Studierende der HAW verfügbar"
            );
          }
          break;

        case "card_formulare":
          this.$router.push({ name: "It3Formulare" });
          break;

        case "card_sap_account":
           if (this.$store.getters.isAdmin) {
            this.$store.commit("setSnackbarText", "Admin-Zugang!");
            this.$router.push({ name: "ecc" });
            break;
          }

          if (!this.$store.getters.isStudent) {
            this.drawer = false; // Close the menue
            this.$store.commit(
              "setSnackbarText",
              "Derzeit nur nach Anmeldung für Studierende der HAW verfügbar."
            );
          } else {
            this.$router.push({ name: "ecc" });
          }

          break;

        case "card_sap_planning_strategies":
          window.open(
            config.getBaseUrl() + "static/bib/books/sap/planning-strategies",
            "_blank"
          );
          break;

        case "card_sap_youtube_planning_strategies":
          window.open(
            "https://www.youtube.com/watch?v=Xpi2ZfarTdI&list=PLfGN40VwjduI8UaiYrOnhoT2RxeSkXIZd",
            "_blank"
          );
          break;

        case "card_sap_youtube_gbi":
          window.open(
            "https://www.youtube.com/watch?v=U6AVLLMT1Vc&list=PLfGN40VwjduL612KTHbxfZOPIIWRhA7T7",
            "_blank"
          );
          break;
      }
    },

    track() {
      this.$ga.page("/");
      console.log("LANDING.VUE : " + "Tracking was called");
    },

    uiEvent(event) {
      console.log("LANDING.VUE : " + "UI Event : " + event);
      switch (event) {
        case "Impressum & Datenschutz":
          this.$router.push({ name: "privacy" });
          return;
      }

      return;
    },
  },

  mounted() {
    // Sign out a user, who is not verified

    let user = firebase.auth().currentUser;
    if (user && !user.emailVerified) {
      firebase.auth().signOut();
      console.log(
        "MOUNED in LANDING signed out user, since e mail is not verified."
      );
    }
  },
};
</script>
